import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
/**
 * GameBackground.ts
 */
export class GameBackground extends AbstractGameView {
    constructor(factory, properties, portraitProperties) {
        super(factory, properties, portraitProperties);
        Logger.addObjectRef(this);
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.baseBackgroundProperties, this.portraitProperties?.baseBackgroundProperties);
        this.frame = TitanSprite.createSprite(this, "frame", this.landscapeProperties.frameProperties, this.portraitProperties?.frameProperties);
    }
}
//# sourceMappingURL=GameBackground.js.map